/**
 * Module Dependencies
 */

import uniques from 'finboxio-uniques'
import dedupe from 'unique-objects'

/**
 * Returns unique values in an array of objects
 * or primitives
 */

export default function uniqs (arr = [], unique_key) {
  return typeof arr[0] === 'object'
    ? dedupe(unique_key, arr)
    : uniques(arr)
}
